import { useAuthMutation } from '@packages/shared/src/hooks/useAuthMutation/useAuthMutation';
import { DeleteProductFromOrderableBasketDocument } from '@packages/gql/generated/shopping/DeleteProductFromOrderableBasketDocument';
import type { DeleteProductFromOrderableBasketMutationVariables } from '@packages/gql/generated/shopping/graphql';
import { storedCheckoutCodes } from '@packages/modules/src/helpers/checkoutCodeStore/checkoutCodeStore';

/* GraphQL */ `
  mutation DeleteProductFromOrderableBasket(
    $locale: String!
    $pli: String!
    $coupons: String
    $loyaltyCoupons: String
  ) {
    deleteProductFromOrderableBasket(
      payload: { locale: $locale, pli: $pli, coupons: $coupons, loyaltyCoupons: $loyaltyCoupons }
    ) {
      __typename
      ... on CheckoutChangedOrderableBasket {
        success
        orderableBasket {
          ...CheckoutOrderableBasketFragment
        }
      }
      ... on CheckoutServerFailure {
        failureMessage
      }
    }
  }
`;

export const useDeleteFromOrderableBasket = () => {
  const [state, execute] = useAuthMutation(DeleteProductFromOrderableBasketDocument);
  const deleteWithCodes = (
    variables: Omit<
      DeleteProductFromOrderableBasketMutationVariables,
      'coupons' | 'loyaltyCoupons'
    >,
  ) => execute({ ...variables, ...storedCheckoutCodes() });

  return [state, deleteWithCodes] as const;
};
